/**
 * Material Taxonomy GraphQL Queries
 * Query for grid view with pagination, filtering, and sorting
 */

import { gql } from '@apollo/client'

export const GET_ALL_MATERIAL_TAXONOMIES = gql`
  query AllMaterialTaxonomies(
    $str: String
    $state: StateEnumOperationFilterInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [TaxonomyPackagingMaterialsFunctionalUnitsGraphQLSortInput!]
  ) {
    # Introspection for StateEnum
    state: __type(name: "StateEnum") {
      name
      enumValues {
        name
        description
      }
    }

    # Introspection for entity schema
    taxonomyPackagingMaterialsFunctionalUnit: __type(
      name: "TaxonomyPackagingMaterialsFunctionalUnitsGraphQL"
    ) {
      fields {
        name
        description
      }
    }

    # Main query for functional units
    taxonomyPackagingMaterialsFunctionalUnits(
      first: $first
      last: $last
      after: $after
      before: $before
      where: {
        id: { gt: 0 }
        or: [
          { state: $state }
          { name: { contains: $str } }
          { code: { contains: $str } }
          { class: { contains: $str } }
          { category: { contains: $str } }
          { lastUpdatedName: { contains: $str } }
          { researcherName: { contains: $str } }
        ]
      }
      order: $order
    ) {
      totalCount
      edges {
        node {
          id
          code
          state
          name
          alias

          # Hierarchy path
          class
          category
          categoryId

          # Properties (storage/reference fields removed per backend)
          transportCondition

          # Verification
          isVerified
          verifiedOn
          verifiedByName
          verifiedByEmail
          verificationComments

          # Audit fields
          created
          updated
          lastPublishedDate
          lastUpdatedName
          userEmail
          researcherName
          researcherEmail
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
